import React from "react";

import {
  BrowserRouter,
  Routes,
  Route,
  Navigate
} from "react-router-dom";

// =========================
// ADMIN PAGES
// =========================

import Login from "./pages/Login";
import Register from "./pages/Register";
import "./App.css";
import AdminDashboard from "./pages/AdminDashboard";
import AdminProducts from "./pages/AdminProducts";
import AdminCategories from "./pages/AdminCategories";
import AdminOrders from "./pages/AdminOrders";
import AdminUsers from "./pages/AdminUsers";

import Gallery from "./pages/Gallery";
import AdminGallery from "./pages/admin/AdminGallery";
 
import Feedback from "./pages/Feedback";
import AdminFeedback from "./pages/AdminFeedback";


// =========================
// CUSTOMER PAGES
// =========================

import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetails from "./pages/ProductDetails";
import CartPage from "./pages/CartPage";
import MyOrders from "./pages/MyOrders";

// =========================
// LAYOUT
// =========================

import AdminLayout from "./components/AdminLayout";

// =========================
// CONTEXT
// =========================

import {
  CartProvider
} from "./context/CartContext";

// =========================
// PRIVATE ROUTE
// =========================



const PrivateRoute = ({
  children
}) => {

  const token =
    localStorage.getItem("token");

  return token
    ? children
    : (
      <Navigate
        to="/login"
        replace
      />
    );
};

// =========================
// APP
// =========================

function App() {

  return (

    <CartProvider>

      <BrowserRouter>

        <Routes>

          {/* =========================
              🌐 PUBLIC
          ========================= */}
          <Route path="/feedback" element={<Feedback />} />
          <Route
            path="/login"
            element={<Login />}
          />

          <Route
            path="/register"
            element={<Register />}
          />

          {/* =========================
              🛍 CUSTOMER
          ========================= */}

          <Route
            path="/"
            element={<Home />}
          />

          {/* ALL PRODUCTS */}
          <Route
            path="/products"
            element={<Products />}
          />

          {/* CATEGORY FILTER */}
          <Route
            path="/products/category/:categoryId"
            element={<Products />}
          />

          {/* PRODUCT DETAILS */}
          <Route
            path="/product/:id"
            element={<ProductDetails />}
          />

          {/* CART */}
          <Route
            path="/cart"
            element={<CartPage />}
          />

          {/* =========================
              📦 MY ORDERS
          ========================= */}

          <Route
            path="/my-orders"
            element={
              <PrivateRoute>
                <MyOrders />
              </PrivateRoute>
            }
          />

          {/* =========================
              🔐 ADMIN
          ========================= */}

          <Route
            path="/admin"
            element={
              <PrivateRoute>
                <AdminLayout />
              </PrivateRoute>
            }
          >

            <Route
              index
              element={<AdminDashboard />}
            />

            <Route
              path="products"
              element={<AdminProducts />}
            />

            <Route
              path="categories"
              element={<AdminCategories />}
            />

            <Route
              path="orders"
              element={<AdminOrders />}
            />

            <Route
              path="users"
              element={<AdminUsers />}
            />
            <Route
                path="feedback"
                element={<AdminFeedback />}
            />
          </Route>
          <Route
          path="/gallery"
          element={<Gallery />}
          />

          <Route
          path="/admin/gallery"
          element={<AdminGallery />}
          />
          {/* =========================
              ❌ FALLBACK
          ========================= */}

          <Route
            path="*"
            element={
              <Navigate
                to="/"
                replace
              />
            }
          />

        </Routes>

      </BrowserRouter>

    </CartProvider>
  );
}

export default App;